// extracted by mini-css-extract-plugin
export default {"toggle":"PayAtTable_toggle__Y7V3Z"};